import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import Buttons from '../../components/UI/Buttons'
import WithRoutify from '../../hoc/WithRoutify';
import { CREATED, OK } from '../../utils/constant';
import {isSet } from '../../utils/commonUtils';
import Alert from '../../components/UI/ConfirmBox/Alert';
import FormInputs from '../../components/UI/FormInputs';
import DropDownService from '../../services/DropDownService';
import AuthorizationTreatmentService from '../../services/AuthorizationTreatmentService';
import FileManagerService from '../../services/FileManagerService';

 class AddAuthorizationTreatment extends Component {
    constructor(props) {
        super(props);
        // Initialize state 
        this.state = {
            showAlert:false,
            formData: {
                employee_name: isSet(`${this.props.employeeDetails.first_name || ""} ${this.props.employeeDetails.middle_name || ""} ${this.props.employeeDetails.last_name || ""}`,""),
                dob: isSet(this.props.employeeDetails?.dob,"" ),
                gender: isSet(this.props.employeeDetails?.gender,""),
                phone: isSet(this.props.employeeDetails?.phone,""),
                company_name:isSet( this.props.savedVisit?.company?.name,""),
                standard_service:isSet(this.props.savedVisit?.standard_service?.physical_name, ""),
                optional_service:isSet(this.props.savedVisit?.optional_services,""),
                reason:isSet(this.props.savedVisit?.visit_reason ,""),
                authorized_by:isSet(this.props.profile?.name,""),
                additional_instructions:"",
                signature:"",
                date:new Date().toLocaleDateString('en-US'),
            },
            ActivityList:[],
            validations:{},
        }
    }
    componentDidMount(){
        this.fetchActivities();        
        if(this.props?.popupData){
          this.fetchAuthorizationData();
        }
    }
    fetchAuthorizationData=async()=>{
        try{
            this.props.Loader(true);
            const data=await AuthorizationTreatmentService.GetById(this.props.visitId);
            console.log("resoone data",this.props.visitId,data );
            
            if(data){
                this.setState(
                  {formData:{
                    ...data,
                }})
            }else{
                // this.props.Toast.error("Something went wrong!")
            }
        }catch(err){
            this.props.Toast.error("Something went wrong!")
        }finally{
            this.props.Loader(false);
        }
    } 
    fetchActivities = async () => {
    
        const response = await DropDownService.getActivityDropdownList(null);
        let opt = [{ "label": 'ALL', value: 'ALL' }];
        response.forEach((itm, ind) => {
          opt.push({ label: itm.activity_name, value: itm.actitivity_id,activity_type: itm.activity_type})
        });
        this.setState({ActivityList:opt})
      }

    formSaveHandler=async()=>{

        const payload = {
            ...this.state.formData,
            visit_id: this.props.visitId,
        }

      try {
      this.props.Loader(true);
      let data={}
      if(payload?.authorization_id){
          data = await AuthorizationTreatmentService.Update(payload.authorization_id,payload);
      }else{
          data = await AuthorizationTreatmentService.Save(payload);
      }
      
      if (data.status && data.status === "ERROR") {
        // if (isObject(data.data)) {
        //   for (let key in data.data) {
        //     updateValidation = {
        //       ...updateValidation,
        //       [key]: data.data[key].join(","),
        //     };
        //   }
        // } else {
        //   props.Toast.error(data.data);
        // }
        // if (Object.keys(updateValidation).length > 0) {
          this.setState({validations:data.data});
        //     FieldValidationFocus(inputFields, updateValidation);         
        // }
      }else if(data.code===CREATED || data.code===OK){
          this.props.Toast.success("Authorization for treatment added successfully")
          this.setState({
            showAlert:false,
            formData:{
                  employee_name: "",
                  dob: "",
                  gender: "",
                  phone: "",
                  company_name: "",
                  standard_service: "",
                  optional_service: "",
                  reason: "",
                  authorized_by: "",
                  additional_instructions: "",
                  signature: "",
                  date: new Date().toLocaleDateString('en-US'),
              },
            validations:{},
            ActivityList:[]})
            this.props.authorizationToogleHandler(false)
        }else{
        this.props.Toast.error("Something went wrong!")
        }
      
    }catch(err){
      this.props.Toast.error("Something went wrong!")

    } finally{
         this.props.Loader(false);
    }}

  resetAndCloseModal = () => {
    this.setState({
        showAlert:false,
        formData: {
            employee_name: "",
            dob: "",
            gender: "",
            phone: "",
            company_name: "",
            standard_service: "",
            optional_service: "",
            reason: "",
            authorized_by: "",
            additional_instructions: "",
            signature: "",
            date: new Date().toLocaleDateString('en-US'),
        },
      ActivityList: [],
    });
    this.props.authorizationToogleHandler(false);
  };
 //triggers when user tries to close the modal 
  handleModalCloseAttempt = () => {
    this.setState({ showAlert: true });
  };

  
  handleAlertClose = () => {
    this.setState({ showAlert: false });
  };

  handleAlertConfirm = () => {
    this.setState({ showAlert: false }, () => {
      this.resetAndCloseModal();
    });
  };

  handleSaveAndClose = async () => {
    this.setState({ showAlert: false }, async () => {
      await this.formSaveHandler();
    });
  };

  onChangeHandler = (fieldName, value,e,label) => {
    let updatedFormData = { ...this.state.formData }
    let validation={...this.state.validations}
    updatedFormData[fieldName] = value;
    validation[fieldName]=""
    this.setState({
      formData: updatedFormData,
      validations:validation,
    });
  }
  tabtoogleHandler=(ind)=>{    
    if(ind>this.state.activeTab){
      this.formSaveHandler(ind)
    }else{
      this.setState({activeTab:ind})
    }

  }
  printHandler=async(id)=>{
    try {
      this.props.Loader(true);
      const response = await AuthorizationTreatmentService.Print(id);
      console.log("print response",response);
      if (response) {
          const pdfData = {
                file_content:response,
                original_name:`${this.state.formData.employee_name}_Authorization_Treatment.pdf`,
                mime_type:'application/pdf'
                
            }
            FileManagerService.printPdf(pdfData);
      } else {
        this.props.Toast.error("Something went wrong!")
      }
    } catch (error) {
      this.props.Toast.error("Something went wrong!")
    } finally {
      this.props.Loader(false);
    }
  }
  
  render() {
    const {validations,formData}=this.state
    const inputFields = this.getInputFieldsTab1()
    return (
      <Modal
        show={true}
        size='xl'
        dialogClassName='hResponsive'
        contentClassName='h-100'
        backdrop="static"
        keyboard={false}
        onHide={this.handleModalCloseAttempt}
      >
        <div className="sh_modalBox">
           
                <Modal.Header closeButton className="pb-0 border-0">
                    <div className="text-lg  px-2 font-weight-bold">Authorization For Treatment</div>
                </Modal.Header>
          <Modal.Body className="pt-2">
           <div className="card-body tab-content p-0">
                          {inputFields.map((section, secIndex) => (
                                              <div className="card mb-2" key={secIndex}>
                                                  <a href={`#collapseCardExample_${secIndex}`} className="d-block sh_accordionheader card-header" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseCardExample" style={{ position: 'sticky', top: '-20px', zIndex: '1' }}>
                                                      <h6 className="mb-0 text-md">{section.title}</h6>
                                                  </a>
                                                  <div className="collapse show" id={`collapseCardExample_${secIndex}`} data-bs-parent="#modal111">
                                                      <div className="card-body">
                                                          <div className="row">
                                                                      {section.data.map((item, itemIndex) => {
                                                                          const value = isSet(formData[item.name], '');
                           
                                                                          return (
                                                                              <div className="col-sm-12" key={itemIndex}>
                                                                                  <div className="form-group row">
                                                                                      <label className="col-sm-3 col-form-label opacity-75">{item.label}</label>
                                                                                      <div className="col-sm-9">
                                                                                              <FormInputs {...item} value={value} changeHandler={(val, e) => this.onChangeHandler(item.name, val, e)} />
                                                                                          {(isSet(validations[item.name], '') !== '' ? <span className="text-danger m-1">{isSet(validations[item.name], '')}</span> : null)}
                                                                                      </div>
                                                                                  </div>
                                                                              </div>
                                                                          )
                                                                      })}
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          ))}
                        </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            
            <Buttons
              type='Single'
              className="btn btn-primary"
              clickHandler={() => this.formSaveHandler()}
              label={this.state.formData?.authorization_id ? 'Update' : 'Save'}
              acl={'any'} 
              />
              
            { this.state.formData?.authorization_id && <Buttons
              type='Single'
              className="btn btn-primary"
              clickHandler={() => this.printHandler(this.state.formData?.authorization_id)}
              label='print'
              acl={'any'}
              />   }                         
            
          </Modal.Footer>
        </div>
        {this.state.showAlert && (
          <Alert
             contentTitle="You have unsaved changes.
            Would you like to save before exiting?." 
            content="Are you sure you want to cancel? This action will not save any of the changes made."
            onClose={this.handleAlertClose}
            onDelete={this.handleAlertConfirm}
            onSaveAndClose={this.handleSaveAndClose}
            type="warning"
            yesButtonName="Confirm"
            noButtonName="Cancel"
            saveAndClose={true} 
          />
        )}
      </Modal>
      
    )
  }
    getInputFieldsTab1 = () => [
        {
            title: 'Patient Details',
            data: [
                { type: "TextInput",readOnly:true, label: "Patient Name", placeholder: "name", className: "form-control form-control-solid", name: "employee_name",value: `${this.props.employeeDetails.first_name} ${this.props.employeeDetails.middle_name} ${this.props.employeeDetails.last_name}` || "", col: 'col-6' },
                { type: "Age",readOnly:true, label: "Age", placeholder: "age", className: "form-control form-control-solid", name: "dob", col: 'col-6', value: this.props.employeeDetails.dob || ""  },
                { type: "TextInput",readOnly:true, label: "Sex", col: 'col-6', placeholder: "Date Reported", className: "form-control form-control-solid", name: "gender", value: this.props.employeeDetails.gender || "" },
                { type: "Date",readOnly:true, label: "DOB", placeholder: "Date of Birth", className: "sh_incidenttime-input", name: "dob", col: 'col-6',  value: this.props.employeeDetails.dob || ""  },
                { type: "Number",readOnly:true, label: "Phone", placeholder: "", className: "form-control form-control-solid", name: "phone", col: 'col-6', value: this.props.employeeDetails.phone || ""   },
                { type: "TextInput",readOnly:true, label: "Company", placeholder: "", className: "form-control form-control-solid", name: "company_name", col: 'col-6', value: this.props.savedVisit.company.name || ""},
            ]
        },
        {
            title: 'Authorization Details',
            data: [
                { type: "TextInput",readOnly:true, label: "Request Contract Service", placeholder: "Request Contract Service", className: "form-control form-control-solid", name: "standard_service", col: 'col-6',  },
                { type: "SelectSearchList",readOnly:true, label: "Requested Optional Service (If Applicable)", placeholder: "Optional Service ", className: "form-control form-control-solid",isMulti:true, name: "optional_service",options:this.state.ActivityList, col: 'col-6',  },
                { type: "TextInput",readOnly:true, label: "Reason For Visit", placeholder: "Reason for Drug Screen", className: "form-control form-control-solid", name: "reason", col: 'col-6',  },
                { type: "TextInput",readOnly:false, label: "Authorized By", placeholder: "Authorized By", className: "form-control form-control-solid", name: "authorized_by", col: 'col-6',  },
                { type: "TextArea",readOnly:false, label: "Additional Instructions", placeholder: "Additional Instructions", className: "form-control form-control-solid", name: "additional_instructions", col: 'col-12', rows: 4 },
                { type: "Signature", label: "Signature", placeholder: "", className: "form-control form-control-solid", name: "signature", col: 'col-6',  },
                { type: "Date",readOnly:false, label: "Date", placeholder: "", className: "form-control form-control-solid", name: "date", col: 'col-6',  },
                ]
        }
    ]
}
export default WithRoutify(AddAuthorizationTreatment);
